export default __webpack_public_path__ + "static/media/boy.d7120688.svg";